import { useQuery } from 'react-query';

import Api from '../../api/api';

export const getReportedUserById = async (reportedUserId: string) => {
  const [response, bodyOrError] = await Api.get(`reports/${reportedUserId}/reported-user`);

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useGetReportedUserById = (reportedUserId: string) =>
  useQuery(['getReportedUserById', reportedUserId], () => getReportedUserById(reportedUserId), {
    enabled: reportedUserId !== 'new' || !!reportedUserId,
  });
